import React from 'react';
// icons
import FamilyShieldCloudsIcon from '@nmx/template/dist/componentLibrary/foundations/Illustration/illustrations/darkTheme/FamilyShieldClouds';
// styles
import { ExperienceCalloutStyled } from './styles';

export default () => (
  <ExperienceCalloutStyled
    assistiveText='Use our life insurance calculator to find out how much life insurance is right for you'
    isFullWidth
    withBGImage={false}
    sectionId='life-insurance-calc-experience-callout'
    illustration={FamilyShieldCloudsIcon}
    headingText='Life Insurance Calculator'
    descriptionText='How much life insurance is right for you&#63;'
    linkUrl='/life-insurance/life-insurance-calculator/'
    buttonText='Calculate it'
    moduleName='tool-experience-module'
    moduleVariation='A'
    backgroundVariant='darkDefault'
    calloutBackgroundVariant='darkDefault'
    calloutThemeType='darkTheme'
    themeType='darkTheme'
  />
);
